import { Injectable } from '@angular/core';
import { Firestore, collection, addDoc, deleteDoc, updateDoc, doc, query, where, orderBy } from '@angular/fire/firestore';
import { Relief } from '../components/shared/models/relief';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ReliefService {
  currentUser: string;

  constructor(
    private firestore: Firestore,
    private router: Router,
    private _authService: AuthService
  ) {
    this.currentUser = this._authService.currentUser?.uid ?? '';
  }

  // Add new Relief to Firestore
  newRelief(relief: Relief) {
    const colRef = collection(this.firestore, 'reliefs');
    return addDoc(colRef, relief).then(() => {
      this.router.navigate(['/relief']);
    });
  }

  // Get all Reliefs for current user ordered by createdAt desc
  getReliefs() {
    const colRef = collection(this.firestore, 'reliefs');
    return query(colRef,
      where('userId', '==', this.currentUser),
      orderBy('createdAt', 'desc')
    );
  }

  // Delete a Relief by document ID
  async deleteRelief(id: string) {
    const docRef = doc(this.firestore, 'reliefs', id);
    return deleteDoc(docRef);
  }

  // Update a Relief
  updateRelief(relief: Relief & { id: string }) {
    const { id, ...data } = relief;
    const docRef = doc(this.firestore, 'reliefs', id);
    return updateDoc(docRef, { ...data });
  }

  // Get reliefs marked for deletion that have expired
  getExpiredReliefs(now: Date) {
    const colRef = collection(this.firestore, 'reliefs');
    return query(colRef,
      where('deleteIn24h', '==', true),
      where('deleteAt', '<=', now)
    );
  }
}
